import { serverPagination } from '@appInterfaces/general.interfaces';
import { IPitch, ITokenPitchDetails } from '@appInterfaces/pitch.interfaces';
import { EPitchStatus } from '@enums/EPitchStatus';
import { EPitchSpecialization } from '@enums/EPitchSpecialization';

class PitchMockServiceClass {
  public getPitches(company_id = 200): serverPagination<IPitch[]> {
    return {
      total_count: 120002,
      total_pages: 12001,
      per_page: 10,
      page: 12001,
      items: [
        {
          company_id,
          id: 123,
          slug: 'kraken_slug',
          title: 'lorem ipsum kraken pitch title',
          status: EPitchStatus.closed,
          image_url: 'https://awus.kekekeke.com/img/bla.png',
          specialisation_id: 4224,
          specialisation_type: EPitchSpecialization.fundPitch,
        },
        {
          company_id,
          id: 124,
          slug: 'bitfinex_slug',
          title: 'lorem ipsum kraken pitch title',
          status: EPitchStatus.live_listed,
          image_url: 'https://awus.kekekeke.com/img/bla.png',
          specialisation_id: 4225,
          specialisation_type: EPitchSpecialization.equityPitch,
        },
        {
          id: 125,
          company_id: 2,
          slug: 'bitfinex_slug',
          title: 'lorem ipsum kraken pitch title',
          status: EPitchStatus.live_listed,
          image_url: 'https://awus.kekekeke.com/img/bla.png',
          specialisation_id: 4225,
          specialisation_type: EPitchSpecialization.tokenPitch,
        },
      ],
    };
  }

  public getTokenPitchesDetails = (
    company_id = 200
  ): serverPagination<ITokenPitchDetails[]> => {
    return {
      total_count: 120002,
      total_pages: 12001,
      per_page: 10,
      page: 12001,
      items: [
        {
          company_id,
          id: 123,
          token_name: 'BFT Token',
          token_symbol: 'bft',
          security: false,
          distributed: false,
        },
        {
          company_id,
          id: 124,
          token_name: 'Heavy Token',
          token_symbol: 'hvt',
          security: true,
          distributed: true,
        },
      ],
    };
  };
}

const PitchMockService = new PitchMockServiceClass();

export default PitchMockService;
